import * as React from 'react';
import s from './QuoteInfo.scss';
import get from 'lodash.get';
import { Text } from '@wix/design-system';
import { dateFormat, localDate } from '../../../core';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { WithQuoteInfoLoader, } from '../../loaders/loaders-builder';
import { dateFormatter } from '@wix/crm-financial-formatters';
const QuoteInfo = ({ t, priceQuote, locale, primarySiteLocale, }) => {
    const date = primarySiteLocale
        ? dateFormatter(primarySiteLocale)
        : localDate(dateFormat({ locale }));
    const issueDate = get(priceQuote.dates, 'issueDate');
    const validThroughDate = get(priceQuote.dates, 'validThroughDate');
    return (React.createElement("div", { className: s.info },
        React.createElement(Text, { className: s.number, weight: "thin", size: "tiny", dataHook: "price-quote-number" }, t('invoice-view:price-quote.view.price-quote-number', {
            number: priceQuote.number,
        })),
        !!issueDate && (React.createElement(Text, { className: s.date, weight: "thin", size: "tiny", secondary: true, dataHook: "issue-date" }, t('invoice-view:price-quote.view.issue-date', {
            date: date(new Date(issueDate)),
        }))),
        !!validThroughDate && (React.createElement(Text, { className: s.date, weight: "thin", size: "tiny", secondary: true, dataHook: "expiry-date" }, t('invoice-view:price-quote.view.expiry-date', {
            date: date(new Date(validThroughDate)),
        })))));
};
export default WithQuoteInfoLoader(withTranslation(['invoice-view', 'locale-data'])(QuoteInfo));
//# sourceMappingURL=QuoteInfo.js.map